import { render, staticRenderFns } from "./GlobalCompanies.vue?vue&type=template&id=60676eea&"
import script from "./GlobalCompanies.vue?vue&type=script&lang=js&"
export * from "./GlobalCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports